module.exports = __webpack_public_path__ + "static/media/unibest-scop-2.a52392c7.png";